import { render, staticRenderFns } from "./parameters-order-statuses.vue?vue&type=template&id=78842c64&scoped=true"
import script from "./parameters-order-statuses.vue?vue&type=script&lang=js"
export * from "./parameters-order-statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78842c64",
  null
  
)

export default component.exports